import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  id: "checkout"
};
const _hoisted_2 = {
  key: 0
};
const _hoisted_3 = {
  class: "purchase-cart-heading"
};
const _hoisted_4 = {
  class: "purchase-cart-heading-title"
};
const _hoisted_5 = {
  class: "cart-page-body"
};
const _hoisted_6 = {
  class: "cart-page-left"
};
const _hoisted_7 = {
  class: "cart-page-left-alerts"
};
const _hoisted_8 = {
  class: "cart-page-left-address"
};
const _hoisted_9 = {
  class: "cart-page-right"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_LoadingDots = _resolveComponent("LoadingDots");
  const _component_StatusBar = _resolveComponent("StatusBar");
  const _component_PurchaseCartAlert = _resolveComponent("PurchaseCartAlert");
  const _component_AddressBox = _resolveComponent("AddressBox");
  const _component_CheckoutSummary = _resolveComponent("CheckoutSummary");
  const _component_CartItem = _resolveComponent("CartItem");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_LoadingDots, {
    loading: $data.loading
  }, null, 8, ["loading"]), !$data.loading ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("h2", _hoisted_4, _toDisplayString($options.getI18nMessage('checkout.Title')), 1)]), _createElementVNode("div", null, [_createVNode(_component_StatusBar, {
    steps: $options.steps
  }, null, 8, ["steps"])]), _createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [$data.apiCallFailure ? (_openBlock(), _createBlock(_component_PurchaseCartAlert, {
    key: 0,
    message: $options.getI18nMessage('deliveryDetails.page.trackDelivery.error'),
    icon: 'exclamation-point-icon',
    color: 'error'
  }, null, 8, ["message"])) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_8, [_createVNode(_component_AddressBox, {
    "has-forwarding-agent": $options.hasForwardingAgent,
    "can-change-address": false
  }, null, 8, ["has-forwarding-agent"])])]), _createElementVNode("div", _hoisted_9, [_createVNode(_component_CheckoutSummary, {
    checkoutData: $data.checkoutData
  }, null, 8, ["checkoutData"])])]), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.checkoutEntries, (checkoutEntry, index) => {
    return _openBlock(), _createElementBlock("div", {
      key: index
    }, [_createVNode(_component_CartItem, {
      itemData: checkoutEntry,
      isMultiPo: $options.isMultiPo,
      isUnconfiguredEntry: false,
      isNeedEditEntry: false,
      isNeedRemoveEntry: false,
      isCheckoutPage: true
    }, null, 8, ["itemData", "isMultiPo"])]);
  }), 128))])) : _createCommentVNode("", true)]);
}